module.exports = __webpack_public_path__ + "static/media/2009.d53931b0.svg";